import {
  ServiceEnvironment,
  getServiceEnvironment,
} from './getCurrentScriptUrlContext';

export const STRIPE_VERSION_HEADER = 'stripe-version';
export const STRIPE_API_VERSION = '2020-08-27';

export const getApiHost = () => {
  const serviceEnvironment = getServiceEnvironment();
  const USER = process.env.STRIPE_USER;
  const QUALIFIER = process.env.DEVBOX_QUALIFIER;

  const API_HOST: Record<ServiceEnvironment, string> = {
    devbox: `${USER}-${QUALIFIER}--api-mydev.dev.stripe.me`,
    'tunnel-devbox': `${USER}-api.tunnel.stripe.me`,
    qa: 'qa-api.stripe.com',
    preprod: 'preprod-api.stripe.com',
    prod: 'api.stripe.com',
  };

  return API_HOST[serviceEnvironment];
};

export const getCryptoStandaloneHost = () => {
  const serviceEnvironment = getServiceEnvironment();
  const USER = process.env.STRIPE_USER;
  const QUALIFIER = process.env.DEVBOX_QUALIFIER;

  const CRYPTO_STANDALONE_HOST: Record<ServiceEnvironment, string> = {
    devbox: `${USER}-${QUALIFIER}--crypto_standalone_site-mydev.dev.stripe.me`,
    'tunnel-devbox': `${USER}-crypto-standalone-site.tunnel.stripe.me`,
    qa: 'qa-crypto.stripe.com',
    preprod: 'crypto-standalone-site.preprod.corp.stripe.com',
    prod: 'crypto.stripe.com',
  };
  return CRYPTO_STANDALONE_HOST[serviceEnvironment];
};

export const getCryptoPayinsJsHost = () => {
  const serviceEnvironment = getServiceEnvironment();
  const USER = process.env.STRIPE_USER;
  const QUALIFIER = process.env.DEVBOX_QUALIFIER;

  const CRYPTO_PAYINS_JS_HOST: Record<ServiceEnvironment, string> = {
    devbox: `${USER}-${QUALIFIER}--stripejs-demos-mydev.dev.stripe.me`,
    'tunnel-devbox': `${USER}-stripejs-demos.tunnel.stripe.me`,
    qa: 'js.stripe.com/v3',
    preprod: 'js.stripe.com/v3',
    prod: 'js.stripe.com/v3',
  };
  return CRYPTO_PAYINS_JS_HOST[serviceEnvironment];
};

export const getApiUrl = (url = '/'): string => {
  return `https://${getApiHost()}${url}`;
};

export const getCryptoStandaloneUrl = (url = '/'): string => {
  return `https://${getCryptoStandaloneHost()}${url}`;
};

export const getCryptoPayinsJsUrl = (url = '/'): string => {
  return `https://${getCryptoPayinsJsHost()}${url}`;
};
